import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import FocusWithin from 'react-focus-within';
import styles from './FormInput.module.scss.js';
import FormField, { FormFieldPropTypes, FormFieldInputPropTypes } from '../FormField/index.js';
import { onlyWarnInDevelopmentMode, warnOnFieldProps, warnOfDeprecation } from '../utils/propWarnings.js';

var _excluded = ["autoFocus", "className", "disabled", "formFieldClassName", "isInlineLeft", "isInlineRight", "label", "step", "max", "input", "maxLength", "meta", "min", "placeholder", "prefix", "prefixStyle", "prefixValue", "required", "type", "themeColor", "fieldProps"];
var FormInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    formFieldClassName = _ref.formFieldClassName,
    _ref$isInlineLeft = _ref.isInlineLeft,
    isInlineLeft = _ref$isInlineLeft === void 0 ? false : _ref$isInlineLeft,
    _ref$isInlineRight = _ref.isInlineRight,
    isInlineRight = _ref$isInlineRight === void 0 ? false : _ref$isInlineRight,
    label = _ref.label,
    step = _ref.step,
    max = _ref.max,
    input = _ref.input,
    _ref$maxLength = _ref.maxLength,
    maxLength = _ref$maxLength === void 0 ? '' : _ref$maxLength,
    meta = _ref.meta,
    min = _ref.min,
    placeholder = _ref.placeholder,
    prefix = _ref.prefix,
    prefixStyle = _ref.prefixStyle,
    prefixValue = _ref.prefixValue,
    required = _ref.required,
    type = _ref.type,
    _ref$themeColor = _ref.themeColor,
    themeColor = _ref$themeColor === void 0 ? '#7A34FF' : _ref$themeColor,
    fieldProps = _ref.fieldProps,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  onlyWarnInDevelopmentMode(function () {
    return warnOnFieldProps(fieldProps);
  });
  onlyWarnInDevelopmentMode(function () {
    return warnOfDeprecation(Object.assign({}, formFieldClassName && {
      'formFieldClassName': formFieldClassName
    }));
  });
  var haveError = meta.touched && (meta.error || meta.submitError) && !meta.dirtySinceLastSubmit && !meta.submitting;
  return /*#__PURE__*/React.createElement(FormField, _extends({
    className: formFieldClassName,
    label: label,
    input: input,
    required: required,
    meta: meta
  }, props, fieldProps), /*#__PURE__*/React.createElement(FocusWithin, null, function (_ref2) {
    var _cx, _cx2;
    var isFocused = _ref2.isFocused,
      focusProps = _ref2.focusProps;
    return /*#__PURE__*/React.createElement("div", _extends({}, focusProps, {
      className: cx(styles.container, className)
    }), prefix && prefixValue && /*#__PURE__*/React.createElement("div", {
      className: cx(styles.prefix, (_cx = {}, _cx[styles.prefixError] = haveError, _cx[styles.prefixDisabled] = disabled, _cx[styles.prefixInline] = prefixStyle === 'inline', _cx)),
      style: isFocused ? {
        borderColor: themeColor
      } : {}
    }, /*#__PURE__*/React.createElement("span", null, prefixValue)), /*#__PURE__*/React.createElement("input", _extends({
      className: cx(styles.input, (_cx2 = {}, _cx2[styles.inputIsPrefix] = prefix && prefixValue, _cx2[styles.inputIsInlineLeft] = isInlineLeft, _cx2[styles.inputIsInlineRight] = isInlineRight, _cx2[styles.inputError] = haveError, _cx2[styles.inputDisabled] = disabled, _cx2)),
      disabled: disabled,
      type: type,
      placeholder: placeholder,
      autoFocus: autoFocus,
      id: input.name,
      min: min,
      max: max,
      step: step,
      maxLength: maxLength
    }, input, focusProps, {
      ref: ref,
      style: isFocused ? {
        borderColor: themeColor
      } : {}
    })));
  }));
});
FormInput.displayName = 'FormInput';
FormInput.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disabled: PropTypes.bool,
  fieldProps: PropTypes.shape(FormFieldPropTypes),
  /** This will be deprecated eventually. Instead pass className to the fieldProps */
  formFieldClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  input: PropTypes.shape(FormFieldInputPropTypes),
  isInlineLeft: PropTypes.bool,
  isInlineRight: PropTypes.bool,
  label: PropTypes.node,
  meta: PropTypes.object,
  prefix: PropTypes.bool,
  prefixStyle: PropTypes.string,
  prefixValue: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  required: PropTypes.bool,
  type: PropTypes.oneOf(['password', 'email', 'text', 'number']),
  step: PropTypes.string,
  themeColor: PropTypes.string
};
FormInput.defaultProps = {
  step: null,
  meta: {
    touched: false
  }
};

export { FormInput as default };
//# sourceMappingURL=index.js.map
